<template>
  <div
    class="projects-list"
  >
    <default-card
      v-for="(card, idx) in projects"
      :key="idx"
      :image-path="card.img"
      :card-text="card.name"
      @click-card="selectProject(card.type)"
      :active="activeProject == card.type"
    />
  </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'

import defaultCard from './DefaultCard.vue'

export default {
  name: 'ProjectsList',
  components: {
    defaultCard
  },
  setup () {
    const store = useStore()

    const activeProject = computed(() => {
      return store.getters.getActiveProject
    })

    const selectProject = (val) => {
      store.commit('SetActiveProject', val)
      localStorage.setItem('activeProject', val)
    }

    const projects = [
      {
        id: 1,
        name: 'www.group-sdt.ru',
        img: require('@/assets/images/png/projects-list/image_site.png'),
        type: 'site'
      },
      {
        id: 2,
        name: 'www.sdt-edu.ru',
        img: require('@/assets/images/png/projects-list/image_education.png'),
        type: 'education'
      }
    ]

    return {
      projects,
      activeProject,
      selectProject
    }
  }
}
</script>

<style lang="scss" scoped>
.projects-list {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 32px;

  & > * {
    margin-bottom: 10px;
    margin-right: 10px;
  }
}

</style>
